/**
 * Block colours for the disposition board.
 *
 * Every value here is what the worker calendar renders through `resolveBlockView`, so a
 * technician's day looks the same on both screens. Appointments and tasks delegate to
 * `shared/lib/timelineColors.ts`, which both calendars read; only the two kinds without an owner
 * palette are named here.
 */
import type { ScheduleEntryType } from '@myapp/contract';
import { ABSENCE_CATEGORY_COLOR } from '../../../entities/absence';
import { getAppointmentColors, getTaskColors } from '../../../shared/lib/timelineColors';

/** One colour for every absence category, matching the worker calendar. */
export const ABSENCE_COLOR = ABSENCE_CATEGORY_COLOR;

/** Matches the worker calendar's Pause. */
export const BREAK_COLOR = '#94A3B8';

export interface BlockColors {
  workColor: string;
  /** Colour of the Anfahrt / Abfahrt segments. Equal to `workColor` for absences and breaks. */
  travelColor: string;
}

/**
 * Resolves the colour pair for one entry. `status` is the owning appointment's or task's status;
 * absences and breaks ignore it.
 */
export function getBlockColors(
  kind: ScheduleEntryType,
  status: string | null,
): BlockColors {
  switch (kind) {
    case 'APPOINTMENT':
      return getAppointmentColors(status ?? '');
    case 'TASK':
      return getTaskColors(status ?? '');
    case 'ABSENCE':
      return { workColor: ABSENCE_COLOR, travelColor: ABSENCE_COLOR };
    case 'BREAK':
    default:
      return { workColor: BREAK_COLOR, travelColor: BREAK_COLOR };
  }
}
